



import React, { useEffect } from 'react';
import './WeDelivered.css';
import { FaCheck } from 'react-icons/fa';
import deliveryImage from '../../assets/Aboutimage/african-man-harvesting-vegetables.jpg';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const WeDelivered = () => {
  const navigate = useNavigate();




  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);
  return (
    <div>
      <div className='container-fluid p-3 mt-5 '>
        <div className='row  '>
          <div className='col-md-6 col-sm-12 d-flex justify-content-center flex-column'>
            <h2
              className="we-delivered-heading"
              data-aos="fade-down"
              data-aos-delay="100"
            >
              One Seamless, Intelligent Ecosystem
            </h2>

            <p
              className="we-delivered-desc"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              ShambaSync unifies soil testing, AI drones, satellite monitoring, and a broker-free marketplace. It enables farmers to make informed decisions, reduce guesswork, and boost productivity and profits.            </p>

            <div className="features-list" data-aos="fade-right" data-aos-delay="300">
              <div className="feature-item">
                <div className="check-circle"><FaCheck /></div>
                <span>Soil insights in just 30 minutes for timely, accurate planning</span>
              </div>
              <div className="feature-item">
                <div className="check-circle"><FaCheck /></div>
                <span>Drone spraying that reduces chemical use by 30%</span>
              </div>
              <div className="feature-item">
                <div className="check-circle"><FaCheck /></div>
                <span>Satellite-driven pest alerts that prevent up to 40% in harvest losses</span>
              </div>
              <div className="feature-item">
                <div className="check-circle"><FaCheck /></div>
                <span>Yield improvements by 25%, all while minimizing input waste</span>
              </div>
            </div>

            <div data-aos="zoom-in" data-aos-delay="400">
              <button className="order-button" onClick={() => navigate('/shop')}>
                Shop Now
                <span className="arrow">→</span>
              </button>
            </div>
          </div>

          <div
            className='col-md-6 col-sm-12 '
            data-aos="flip-left"
            data-aos-delay="500"
          >
            <div className='d-flex justify-content-center align-items-center'>
              <img
                src={deliveryImage}
                alt="We Delivered"
                className='img-fluid Delivered_image'
                style={{ borderRadius: "20px" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeDelivered;

